<div
  data-font="uds"
  data-testid="password-form"
  class="password-form relative flex flex-col flex-1 gap-8"
  [ngClass]="{
    'bg-neutral-50 rounded-2xl px-6 py-8 w-[320px] md:w-[512px] md:px-10':
      isDialog,
  }"
>
  <button
    *ngIf="isDialog"
    type="button"
    class="absolute top-4 right-4 flex h-5 w-5 cursor-pointer items-center justify-center bg-transparent"
    data-testid="password-form-close"
    aria-label="Cerrar"
    (click)="closeDialog()"
  >
    <ui-icon
      name="close"
      size="20"
      mobile-size="20"
      fill="neutral-900"
    ></ui-icon>
  </button>

  <ng-container *ngIf="!formSubmitted; else success">
    <digicem-access-header
      icon="lock"
      [heading]="heading"
      [subtitle]="subTitle"
    ></digicem-access-header>

    <form [formGroup]="newPasswordForm" class="flex flex-col gap-4" novalidate>
      <ui-input
        ngDefaultControl
        digicemFormControl
        data-testid="password-new"
        placeholder="Ingresa tu nueva contraseña"
        label="Nueva contraseña"
        label-position="top"
        type="password"
        appearance="outline"
        autocomplete="new-password"
        hint-message=""
        [enabled]="!loading"
        (inputed)="onInputed($any($event), 'newPassword')"
        [error]="newPasswordInvalid"
        [formControl]="$any(control('newPassword'))"
      ></ui-input>

      <ui-input
        #confirmPassword
        ngDefaultControl
        digicemFormControl
        data-testid="password-confirm"
        placeholder="Repite tu nueva contraseña"
        label="Repetir nueva contraseña"
        label-position="top"
        type="password"
        appearance="outline"
        autocomplete="new-password"
        hint-message=""
        [enabled]="!loading"
        (inputed)="onInputed($any($event), 'confirmPassword')"
        [error]="confirmError !== ''"
        [errorMessage]="confirmError"
        [formControl]="$any(control('confirmPassword'))"
      ></ui-input>

      <div class="flex flex-col gap-3">
        <ui-paragraph
          data-testid="password-rules-title"
          type="p14"
          mobile-type="p14"
          text-color="neutral-700"
          font-weight="bold"
          content="Requisitos para tu nueva contraseña:"
        ></ui-paragraph>
        <div
          class="grid grid-cols-1 gap-2 lg:grid-cols-2"
          data-testid="password-rules"
        >
          <digicem-chip-select
            content="Al menos 8 caracteres"
            [selected]="hasMinLength"
          ></digicem-chip-select>
          <digicem-chip-select
            content="Una letra mayúscula"
            [selected]="hasUpperCase"
          ></digicem-chip-select>
          <digicem-chip-select
            content="Una letra minúscula"
            [selected]="hasLowerCase"
          ></digicem-chip-select>
          <digicem-chip-select
            content="Un número"
            [selected]="hasNumber"
          ></digicem-chip-select>
          <digicem-chip-select
            content="Un carácter especial"
            [selected]="hasSpecialChar"
          ></digicem-chip-select>
        </div>
      </div>

      <ui-alert
        *ngIf="error"
        data-testid="password-error"
        type="error"
        shape="square"
        [message]="error"
      ></ui-alert>
    </form>

    <ng-container
      *ngTemplateOutlet="
        actions;
        context: {
          $implicit: buttonText,
          enabled: newPasswordForm.valid,
          primary: true,
        }
      "
    ></ng-container>
  </ng-container>

  <ng-template #success>
    <digicem-access-header
      icon="check"
      tone="success"
      [heading]="titleSuccess"
      [subtitle]="messageSuccess"
    ></digicem-access-header>

    <ng-container
      *ngTemplateOutlet="
        actions;
        context: { $implicit: buttonSuccessText, enabled: true, primary: false }
      "
    ></ng-container>
  </ng-template>

  <ng-template #actions let-label let-enabled="enabled" let-primary="primary">
    <ng-template #button>
      <ui-button
        [attr.data-testid]="primary ? 'password-submit' : 'password-finish'"
        type="primary"
        font-weight="regular"
        [buttonText]="label"
        [customSizeConfig]="buttonSize"
        [enabled]="enabled"
        [isLoading]="primary && loading"
        (clicked)="primary ? onSubmit() : finishForm()"
      ></ui-button>
    </ng-template>

    <div *ngIf="isDialog; else pageActions" class="flex flex-col">
      <ng-container *ngTemplateOutlet="button"></ng-container>
    </div>
    <ng-template #pageActions>
      <digicem-access-actions>
        <ng-container *ngTemplateOutlet="button"></ng-container>
      </digicem-access-actions>
    </ng-template>
  </ng-template>
</div>
